/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ApiResult
 */
export interface ApiResult {
    /**
     * If non-zero, check Message for the error description
     * @type {number}
     * @memberof ApiResult
     */
    errorNo?: number;
    /**
     *
     * @type {string}
     * @memberof ApiResult
     */
    message?: string;
    /**
     *
     * @type {number}
     * @memberof ApiResult
     */
    identity?: number;
    /**
     *
     * @type {string}
     * @memberof ApiResult
     */
    identityStr?: string;
}

/**
 * Check if a given object implements the ApiResult interface.
 */
export function instanceOfApiResult(value: object): value is ApiResult {
    return true;
}

export function ApiResultFromJSON(json: any): ApiResult {
    return ApiResultFromJSONTyped(json, false);
}

export function ApiResultFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ApiResult {
    if (json == null) {
        return json;
    }
    return {
        errorNo: json["errorNo"] == null ? undefined : json["errorNo"],
        message: json["message"] == null ? undefined : json["message"],
        identity: json["identity"] == null ? undefined : json["identity"],
        identityStr:
            json["identityStr"] == null ? undefined : json["identityStr"],
    };
}

export function ApiResultToJSON(value?: ApiResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        errorNo: value["errorNo"],
        message: value["message"],
        identity: value["identity"],
        identityStr: value["identityStr"],
    };
}
